package uz.ferro.erp.feature.order.model

import kotlinx.serialization.Serializable

@Serializable
data class Usage(
    val status: String?,
    val packages: List<PackageInfo>?
)
